import React from "react";
import PropTypes from "prop-types";
import { Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import CheckboxRow from "./CheckboxRow";
import useMediaQuery from "@mui/material/useMediaQuery";

Positions.propTypes = {
  roles: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
      name: PropTypes.string.isRequired,
    })
  ).isRequired,
  selectedRoleIds: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string])).isRequired,
  onChangeSelectedRoleIds: PropTypes.func.isRequired,
};

export default function Positions({ roles, selectedRoleIds, onChangeSelectedRoleIds }) {
  const toggleRole = (roleId) => {
    const nextRoleIds = selectedRoleIds.includes(roleId)
      ? selectedRoleIds.filter((id) => id !== roleId)
      : [...selectedRoleIds, roleId];

    onChangeSelectedRoleIds(nextRoleIds);
  };


  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box 
      sx={{
        ...( !isMobile && {
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          columnGap: 3,
          rowGap: 1,
        })
      }}>
      {roles.map((role) => (
        <CheckboxRow
          key={role.id}
          label={role.name}
          checked={selectedRoleIds.includes(role.id)}
          onChange={() => toggleRole(role.id)}
        />
      ))}
    </Box>
  );
}